<div class="c-master-data-cards">

  <ng-container *ngIf="dataSource?.length">
    <cdk-virtual-scroll-viewport appendOnly itemSize="50"
      class="c-master-data-cards__height"
      [ngClass]="isItemsView ? 'c-master-data-cards__height--items-view' : ''">
      <app-master-data-card
        *cdkVirtualFor="let item of dataSource; let i = index"
        [item]="item"
        [cardProperties]="objectDefinition.columns"
        [objectDefinition]="objectDefinition"
        (itemActionEvent)="itemActionEvent.emit($event)"
        [isItemsView]="isItemsView"
        [isSelectable]="true"
        [isEditMode]="isEditMode">
      </app-master-data-card>
    </cdk-virtual-scroll-viewport>
  </ng-container>

</div>
